<template>
    <div class="table-responsive">
        <table>
            <thead>
                <tr>
                    <th>Descripción</th>
                    <th>Precio</th>
                    <th>
                        <div>
                            <button @click="agregar" class="btn-success"><i class="fa fa-plus"></i><span>Agregar</span></button>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(precio, index) in modelValue" :key="index">
                    <td>
                        <div class="form-field">
                            <input-field :id="'descripcion' + index" 
                                v-model="modelValue[index].descripcion">
                                <span v-if="errores.hasOwnProperty('precios.' + index + '.descripcion')" class="helper-text text-danger" slot="helper">
                                    {{ errores['precios.' + index + '.descripcion'][0] }}
                                </span>
                            </input-field>
                        </div>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field vMoney :format="money" :id="'precio' + index" 
                                v-model="modelValue[index].precio">
                                <span v-if="errores.hasOwnProperty('precios.' + index + '.precio')" class="helper-text text-danger" slot="helper">
                                    {{ errores['precios.' + index + '.precio'][0] }}
                                </span>    
                            </input-field>
                        </div>
                    </td>
                    <td>
                        <div>
                            <button @click="eliminar(index)" class="btn-danger btn--text"><i class="fa fa-trash"></i></button>
                        </div>
                    </td>
                </tr>
                <tr v-show="modelValue.length == 0">
                    <td colspan="3">
                        <strong>No se ha agregado precios.</strong>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        errores: {
            type: Object,
            required: false,
            default: function () {
                return {};
            }
        }, 
        value: {
            type : Array,
            required: false,
            default: function () {
                return [];
            }
        }
    },
    data: function () {
        return {
            modelValue: this.value,
            money: money2
        };
    },
    methods: {
        agregar: function () {
            this.modelValue.push({
                descripcion: '',
                precio: 0
            });
        },
        eliminar: function (index) {
            this.modelValue.splice(index, 1);
        }
    },
    watch: {
        value: function (value) {
            this.modelValue = value;
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/items/Precios.vue